<template>
  <div
    v-show="isShowCombobox"
    class="box-wrap vip-mandate-wrap"
    @click.stop="navigatorTo"
  >
    <div class="explain-box">
      <span>为促进正版设计的发展，即日起，凡主动购买潮国创意正版内容商业授权的用户，方可享有超惠价格。</span>
      <span class="color-brown">若未经潮国创意授权使用，不仅全额支付最高版权使用费，并按侵权责任赔偿损失，且承担一切法律后果。</span>
    </div>

    <div class="box-item-wrap">
      <div
        class="box-left box-item business"
      >
        <div class="box-card-wrap">
          <div class="box-card">
            <div class="box-header">
              <h3 class="headline">{{ PERSON_VIP.label }}</h3>
              <div class="subhead">{{ PERSON_VIP.desc }}</div>
              <i class="icon_zs"/>
            </div>

            <div class="content">
              <div class="title">下载范围</div>
              <div class="down-scope">
                <div class="down-scope-item" v-for="item in PERSON_VIP.downScope">
                  <i :class="[ 'iconfont', item.scope ? 'icon-gou3': 'icon-cha3' ]"/>
                  {{ item.label }}
                </div>
              </div>

            </div>
          </div>

          <div class="use-scope">
            <ul class="box-permission">
              <li
                v-for="(permItem,permIndex) in PERSON_VIP.useScope"
                :key="permIndex + 'PERM'"
                class="perm-item"
                :class="[{ 'normal':!permItem.scope}]"
              >
                <i
                  :class="[ permItem.scope  ? ' icon-gou': 'icon-cha2' ]"
                  class="iconfont"
                />
                <span class="perm-name">{{ permItem.label }} </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="box-list ">
          <div
            v-for="(mealItem,mealIndex) in VIP_LIST"
            :key="mealIndex + 'MEAL'"
            class="meal-item"
            :class="{ 'active': mealIndex == mealListIndex }"
            @mouseover=" mealListIndex = mealIndex"
            @click.stop="tag('充值:商用授权下拉:图片');"
          >
            <NavigationTo :path="PAY_DEFAULT + '/'+ mealItem.ID">
              <div slot="content">
                <!-- 推荐图标 -->
                <div class="text-recommend" v-if="mealItem.ID == 1">
                  推荐
                </div>
                <div class="meal-duration">
                  {{ mealItem.DURATION }}
                </div>
                <div class="meal-price">
                  <i class="icon_price">￥</i><span class="price">{{ mealItem.PRICE }}</span>
                </div>
                <div class="resources-download">
                  {{ mealItem.DOWN_NUMBER }}
                </div>
              </div>
            </NavigationTo>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {tag} from "@/utils/statUtil";
import {PERSON_VIP} from "@/constant/_Privately/Vip"
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";
import {disposeVipList} from "@/fn/_Privately/Vip";
import {INTRODUCE_VIP, PAY_DEFAULT} from "@/constant/_Public/Path";
import {fnRouter} from "@/fn";

/* 下拉普通VIP列表 */
const VIP_LIST = [
  {...VIP_MANAGE.PERSON.YEAR},
  {...VIP_MANAGE.PERSON.QUARTER},
  {...VIP_MANAGE.PERSON.MONTH},
  /*{...VIP_MANAGE.PERSON.YEAR_FIVE},*/
  {...VIP_MANAGE.PERSON.FOREVER},
]

export default {
  name: "VipMandateCombobox",

  mounted() {
  },
  data() {
    return {
      PAY_DEFAULT,
      isShowCombobox: false,
      PERSON_VIP,
      INTRODUCE_VIP,
      VIP_LIST: disposeVipList(VIP_LIST),
      mealListIndex: 0
    }
  },
  methods: {
    tag(stat) {
      tag(stat)
    },
    navigatorTo(path) {
      fnRouter.navigationTo(INTRODUCE_VIP)
    },
  }
}
</script>

<style lang="scss" scoped>

@keyframes fadeinT {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


.box-wrap {

  width: 580px;

  color: rgba(66, 72, 102, 1);

  .box-item-wrap {
    padding: 16px 22px 23px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .explain-box {
    height: 70px;
    background: #F7F7F9;
    border-radius: 12px 12px 0px 0px;

    font-size: 11px;
    color: #585A5C;
    line-height: 16px;
    letter-spacing: 1px;
    display: flex;
    flex-direction: column;
    padding: 17px 24px;
    box-sizing: border-box;

    span {
      margin-bottom: 5px;

      &.color-brown {
        color: rgba(130, 73, 35, 1);
      }
    }
  }

  //width: 712px;
  //height: 432px;
  background: #FFFFFF;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.06), 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  //padding: 20px 22px 24px;
  animation: fadeinT 0.5s 1;

  .box-left {

    &:last-child {
      margin-right: 0;
    }

    .box-card-wrap {
      width: 532px;
      height: 174px;
      border-radius: 12px;
      display: flex;
      background: #F7F7FF;
    }

    .box-card {
      width: 290px;
      border-radius: 12px;
      overflow: hidden;
      height: 174px;
      background: #6969FF !important;
      flex-shrink: 0;

      .content {
        width: 278px;
        height: 112px;
        background: #FFFFFF;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 6px 6px;
        position: relative;
        z-index: 10;

        .title {
          font-size: 13px;
          color: #71758C;
          line-height: 20px;
          margin: 12px 0;
          position: relative;

          &:after {
            content: '';
            display: inline-block;
            width: 88px;
            border-bottom: 1px dashed #C5CBE6;
            position: absolute;
            left: -96px;
            top: 50%;
            transform: translateY(-50%);
          }

          &:before {
            content: '';
            display: inline-block;
            width: 88px;
            border-bottom: 1px dashed #C5CBE6;
            position: absolute;
            left: 60px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .down-scope {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: center;

          .down-scope-item {
            height: 24px;
            background: #F7F7F7;
            border-radius: 4px;
            padding: 0 8px;
            font-size: 13px;
            color: #424866;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin: 0 10px 8px 0;

            .iconfont {
              font-size: 14px;
              margin-right: 4px;

              &.icon-gou3 {
                color: #36D0BA;
              }

              &.icon-cha3 {
                color: #B5B6C2;
              }
            }


          }
        }
      }
    }

    .use-scope {
      width: 242px;
      padding: 18px 0 0 22px;

      .box-permission {
        display: flex;
        flex-wrap: wrap;

        .perm-item {
          width: 88px;
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          line-height: 16px;
          margin-right: 38px;

          &:nth-child(2n) {
            margin-right: 0;
          }


          .iconfont {
            font-size: 16px;
            margin-right: 4px;

            &.icon-gou {
              color: #6969FF;
            }

            &.icon-cha2 {
              color: rgba(66, 72, 102, 0.45);
            }
          }

          .perm-name {
            color: #424866;
            font-size: 13px;
          }

          &.normal {
            .perm-name {
              color: rgba(66, 72, 102, 0.45);
            }
          }
        }
      }
    }

    &.person {
      position: relative;

      &:after {
        content: "";
        width: 1px;
        height: 388px;
        //border-left: 1px dotted #EBEDF5;
        @include Position(1, 5, -19px, 0);
      }
    }


  }

  @mixin VipCard($background,$headerBg,$gouColor:#6969FF,$chaColor:#6969FF) {
    .box-card {
      background: $background;

      .box-header {
        height: 56px;
        box-sizing: border-box;
        background-color: $headerBg;
        text-align: center;
        padding: 9px 0 0;
        position: relative;

        .icon_zs {
          @include Position(1, 2, 0, 0);
        }


        .headline {
          margin-bottom: 2px;
          font-size: 16px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 22px;
          letter-spacing: 1px;
        }

        .subhead {
          color: #FFFFFF;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 1px;
        }
      }


    }

    .box-list {
      display: flex;
      //justify-content: space-between;
      margin-top: 18px;

      .meal-item {
        width: 86px;
        height: 92px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #EBEDF5;
        margin-right: 13px;
        box-sizing: border-box;
        position: relative;
        //overflow: hidden;
        text-align: center;
        transition: all 0.5s ease-in;
        cursor: pointer;

        width: 122px;
        height: 92px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #EBEDF5;

        /* 推荐 */
        .text-recommend {
          //width: 34px;
          padding: 0 5px;
          background: linear-gradient(224deg, #FF906F 0%, #FF5E9F 100%);
          border-radius: 12px 2px 12px 2px;
          font-size: 12px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 18px;
          @include Position(1, 5, -1px, -9px);
        }

        .meal-duration {
          margin: 10px 0 5px;
          font-size: 13px;
          font-weight: bold;
          color: #424866;
          line-height: 18px;
        }

        .meal-price {
          font-size: 0;
          height: 38px;
          color: #4C4B51;

          .icon_price {
            //margin-right: 2px;
            vertical-align: 1px;
            font-size: 12px;
            font-weight: bold;
            line-height: 16px;
          }

          .price {
            font-weight: bold;
            font-size: 18px;
            line-height: 24px;
          }
        }

        .resources-download {
          @include Position(1, 4, 0, 0);
          right: 0px;
          //width: 100%;
          line-height: 28px;
          background-color: $background;
          text-align: center;
          color: $headerBg;
          border-radius: 0 0 7px 7px;
          z-index: 2;
          font-size: 12px;

        }

        .meal-duration,
        .meal-price,
        .resources-download,
        {
          transition: all 0.3s ease-in;
        }

        &.active {
          border-color: $headerBg;

          .meal-duration {
            color: #424866;
          }

          .meal-price {
            color: $headerBg;
          }

          .resources-download {
            background-color: $headerBg;
            color: #FFFFFF;
          }

        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  /* 普通Vip */
  .person {
    @include VipCard(#EAFAF8, #35D0BA, #35D0BA);

    .icon_zs {
      @include BgImage(80px, 76px, 'vip/icon_zs_person.png')
    }
  }

  /* 商用Vip */
  .business {
    @include VipCard(#F7F7FF, #6969FF, #6969FF);

    .icon_zs {
      @include BgImage(80px, 76px, 'vip/icon_zs_business.png')

    }

  }
}
</style>

<!--
  商用会员授权下拉
-->

